import "./PainScore.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import moment from "moment";

const PainScore = () => {
  let { id } = useParams();
  let { program_id } = useParams();
  const [thisWeekPainData, setThisWeekPainData] = useState(0);
  const [thisWeekPainPoints, setThisWeekPainPoints] = useState(0);
  const [dayOnePainScale, setDayOnePainScale] = useState(0);
  const [lastCheckedPain, setLastCheckedPain] = useState("");
  const [lastCheckedPoints, setLastCheckedPoints] = useState("");
  const [lastWeekPainData, setLastWeekPainData] = useState(0);

  const [totalPointCount, setTotalPointCount] = useState(0);
  const [lastWeekPointCount, setLastWeekPointCount] = useState(0);
  const [lastWeekCheckDate, setLastWeekCheckDate] = useState("");
  const [dayOnePoints, setDayOnePoints] = useState(0);

  const [painScaleHistory, setPainScaleHistory] = useState([]);
  const [painScaleColor, setPainScaleColor] = useState([]);

  useEffect(() => {
    if (id !== undefined && program_id !== undefined) {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_therapist/pain_details", { id, program_id })
        .then((res) => {
          if (res.data.responseData) {
            if (res.data.responseData.thisWeek) {
              setThisWeekPainData(res.data.responseData.thisWeek);
            }
            if (res.data.responseData.dayOnePain) {
              setDayOnePainScale(res.data.responseData.dayOnePain);
            }
            if (res.data.responseData.pain_level_difference) {
              setThisWeekPainPoints(res.data.responseData.pain_level_difference);
            }
            if (res.data.responseData.pain_level_date) {
              setLastCheckedPain(res.data.responseData.pain_level_date);
            }
            if (res.data.responseData.lastWeek) {
              setLastWeekPainData(res.data.responseData.lastWeek);
            }
            if (res.data.responseData.points_date) {
              setLastCheckedPoints(res.data.responseData.points_date);
            }
            if (res.data.responseData.totalPointCount) {
              setTotalPointCount(res.data.responseData.totalPointCount);
            }
            if (res.data.responseData.lastWeekPoints) {
              setLastWeekPointCount(res.data.responseData.lastWeekPoints);
            }
            if (res.data.responseData.lastWeekCheckDate) {
              setLastWeekCheckDate(res.data.responseData.lastWeekCheckDate);
            }
            if (res.data.responseData.dayOnePoints) {
              setDayOnePoints(res.data.responseData.dayOnePoints);
            }

            if (res.data.responseData.chart_data) {
              setPainScaleHistory(res.data.responseData.chart_data);
              setPainScaleColor(res.data.responseData.chart_color);
            }
            getUpcomingDates();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [id]);

  const [upcomingDates, setUpcomingDates] = useState([]);
  const getUpcomingDates = () => {
    var allDatesArr = [];
    var dateLoop = new Date();
    for (var i = 0; i < 15; i++) {
      let date = new Date(dateLoop).setDate(new Date(dateLoop).getDate() - i);
      date = moment(date).format("M/D");
      allDatesArr.unshift(date);
    }
    setUpcomingDates(allDatesArr);
  };

  const painScaleObj = {
    title: {
      text: "",
    },
    chart: {
      style: {
        fontFamily: "Epilogue",
      },
      backgroundColor: "#f7fafb",
      height: 80,
    },
    xAxis: {
      maxPadding: 0,
      type: "datetime",
      categories: upcomingDates,
      tickmarkPlacement: "on",
      lineWidth: 0,
      labels: {
        enabled: false,
      },
    },
    yAxis: {
      max: 10,
      title: {
        text: "",
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      area: {
        lineColor: painScaleColor,
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, Highcharts.color(painScaleColor).setOpacity(0.5).get("rgba")],
            [1, Highcharts.color(painScaleColor).setOpacity(0).get("rgba")],
          ],
        },
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        lineWidth: 3,
        threshold: null,
      },
    },
    series: [
      {
        type: "area",
        pointPlacement: "on",
        name: "Pain Level",
        data: painScaleHistory,
      },
    ],
  };

  return (
    <div className="patient_list_container pain_score_container">
      <div className="pain_score_top mb-16">
        <div className="title_container mb-16">
          <div className="title_painscore">Pain Score</div>
          {/* <div className="painscore_level">
            Day 1: {dayOnePainScale},{" "}
            {dayOnePainScale <= 2 && dayOnePainScale > 0
              ? "Mild"
              : dayOnePainScale > 2 && dayOnePainScale <= 4
              ? "Moderate"
              : dayOnePainScale > 4 && dayOnePainScale <= 6
              ? "Severe"
              : dayOnePainScale > 6 && dayOnePainScale <= 8
              ? "Most Severe"
              : dayOnePainScale > 8 && dayOnePainScale <= 10
              ? "Unbearable"
              : "No Data"}
          </div> */}
        </div>
        <div className="score_card">
          <div className="score_card_top">
            <div className="score_card_icon">Pain Score</div>
            {/* <div className="scard_button">Open Graph</div> */}
          </div>
          <div className="score_card_separator">
            <div className="score_card_main">
              {thisWeekPainData}
              {/* {", "} 
             {thisWeekPainData <= 2 && thisWeekPainData > 0
              ? "Mild"
              : thisWeekPainData > 2 && thisWeekPainData <= 4
              ? "Moderate"
              : thisWeekPainData > 4 && thisWeekPainData <= 6
              ? "Severe"
              : thisWeekPainData > 6 && thisWeekPainData <= 8
              ? "Most Severe"
              : thisWeekPainData > 8 && thisWeekPainData <= 10
              ? "Unbearable"
              : "No Data"} */}
            </div>
            <div className={"score_card_points " + (thisWeekPainPoints > 0 ? " score_card_points_red" : "")}>
              <span>{thisWeekPainPoints}pts</span>
            </div>
            {/* <div className="score_card_bottom">
            last check-in {lastCheckedPain ? moment(lastCheckedPain).format("ll") : "No data"}
          </div> 
          <div className="score_card_top">
            <div className="score_card_icon">Last Week</div>
             <div className="score_card_points">
              <span>-5pts</span>
            </div> 
          </div>
          <div className="score_card_main">
            {lastWeekPainData}
             {lastWeekPainData <= 2 && lastWeekPainData > 0
              ? "Mild"
              : lastWeekPainData > 2 && lastWeekPainData <= 4
              ? "Moderate"
              : lastWeekPainData > 4 && lastWeekPainData <= 6
              ? "Severe"
              : lastWeekPainData > 6 && lastWeekPainData <= 8
              ? "Most Severe"
              : lastWeekPainData > 8 && lastWeekPainData <= 10
              ? "Unbearable"
              : "No Data"} 
          </div>*/}
            <div className="score_card_bottom">Last Time: {lastWeekPainData}</div>
            <div className="score_card_bottom">
              At Signup: {dayOnePainScale}
              {/* {dayOnePainScale <= 2 && dayOnePainScale > 0
              ? "Mild"
              : dayOnePainScale > 2 && dayOnePainScale <= 4
              ? "Moderate"
              : dayOnePainScale > 4 && dayOnePainScale <= 6
              ? "Severe"
              : dayOnePainScale > 6 && dayOnePainScale <= 8
              ? "Most Severe"
              : dayOnePainScale > 8 && dayOnePainScale <= 10
              ? "Unbearable"
              : "No Data"}{" "} */}
            </div>
          </div>
          <div className="score_card_separator">
            <HighchartsReact highcharts={Highcharts} options={painScaleObj} />
          </div>
        </div>
      </div>
      {/* <div className="pain_score_top mb-16">
        <div className="title_container mb-16">
          <div className="title_painscore">Points</div>
          <div className="painscore_level">Day 1: {dayOnePoints} pts</div>
        </div>
        <div className="score_card">
          <div className="score_card_top">
            <div className="score_card_trophy">Current Score</div>
          </div>
          <div className="score_card_main">{totalPointCount + " pts"}</div>
          <div className="score_card_bottom">
            last check-in {lastCheckedPoints ? moment(lastCheckedPoints).format("ll") : "No Data"}
          </div>
        </div>
        <div className="score_card ml-24">
          <div className="score_card_top">
            <div className="score_card_trophy">Last Week</div>
          </div>
          <div className="score_card_main">{lastWeekPointCount + " pts"}</div>
          <div className="score_card_bottom">
            last check-in {lastWeekCheckDate ? moment(lastWeekCheckDate).format("ll") : "No Data"}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default PainScore;
